import React from 'react';
import Lottie from 'lottie-react';
import { Box } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid-premium';
import useLottieAnimation from 'src/hooks/useLottieAnimation';

const LottieLoadingOverlay = () => {
  const { animationData } = useLottieAnimation();

  return (
    <GridOverlay>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(2px)',
          position: 'relative',
          zIndex: 1000,
        }}
      >
        {animationData ? (
          <Lottie
            animationData={animationData}
            style={{ height: 200, width: 200 }}
            loop={true}
            autoplay={true}
          />
        ) : (
          <Box
            sx={{
              width: 200,
              height: 200,
              bgcolor: 'grey.200',
              borderRadius: '50%',
            }}
          />
        )}
      </Box>
    </GridOverlay>
  );
};

export default LottieLoadingOverlay;
